import _ from 'lodash';
import translate from '../../../../scripts/core/tools/translate';

const LayerControls = (name) => require('../../../../scripts/controls').get(name);
const layers = () => require('../../../../scripts/layers').default;

export class RetentionFilterFactory {
    constructor ({ options, currentMap }) {
        this.options = options;
        this.currentMap = currentMap;
    }

    getData () {
        const features = layers().get('Retention', this.currentMap).getFeatures();
        const types = LayerControls('Retention').getTypes();

        const data = [{
            name: 'brands',
            position: 1,
            fields: [{
                title: translate('Common.Category'),
                name: 'type',
                dataSource: _.map(types, t => ({
                    text: translate(`Retention.Classification.${t.type}`),
                    value: t.type
                })),
                value: 'value',
                text: 'text',
                type: 'multiselect'
            }]
        }];

        if (_.size(features)) {
            const dataSources = {
                group: _(features)
                    .filter(f => _.some(types, t => t.type === f.properties.type) && f.properties.group)
                    .map(f => ({ text: f.properties.group, value: f.properties.group }))
                    .uniqBy('text')
                    .orderBy('text')
                    .value(),
                family: _(features)
                    .filter(f => f.properties.family && _.some(types, t => t.type === f.properties.type))
                    .map(f => ({ text: f.properties.family, value: f.properties.family }))
                    .uniqBy('text')
                    .orderBy('text')
                    .value(),
                revisionKM: _(features)
                    .map((f) => ({ text: f.properties.revisionKM, value: f.properties.revisionKM }))
                    .uniqBy('text')
                    .orderBy('text')
                    .value()
            };

            if (_.size(dataSources.group)) {
                data.push({
                    name: 'group',
                    position: 2,
                    fields: [{
                        title: translate('Common.Groups'),
                        name: 'group',
                        dataSource: dataSources.group,
                        value: 'value',
                        text: 'text',
                        skipAll: true,
                        type: 'multiselect'
                    }]
                });
            }

            if (_.size(dataSources.family)) {
                data.push({
                    name: 'family',
                    position: 3,
                    fields: [{
                        title: translate('Common.Family'),
                        name: 'family',
                        dataSource: dataSources.family,
                        value: 'value',
                        text: 'text',
                        skipAll: true,
                        type: 'multiselect'
                    }]
                });
            }

            data.push({
                name: 'revisionKM',
                position: 4,
                fields: [{
                    title: translate('Common.Revision'),
                    name: 'revisionKM',
                    dataSource: dataSources.revisionKM,
                    value: 'value',
                    text: 'text',
                    type: 'multiselect',
                    index: 0
                }]
            });
        }

        return data;
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/filters/factory/retention.factory.js